import "./styles.css"

import { t } from "i18next"
import React, { use,useEffect, useState  } from "react"
import { Link, useNavigate } from "react-router-dom"

import { queryClient } from "../.."
import leftArrow from "../../assets/common/prvsArrow.svg"
import CustomDropdown from "../../components/Common/Form/Dropdown"
import Pagination from "../../components/Common/Pagination"
import Table from "../../components/Tables"
import ToastNotification, { notify } from "../../components/Toast"
import { DownloadPriceEngineSimulation } from "../../services/mutations"
import {
    useGetArticleDetails,
    useGetFilteredPriceEngineSimulation,
    useGetPriceListNames,
    useGettypeNumberList
} from "../../services/queries"
import { PAGINATION } from "../../utils/Constant"
import { customNotification, formatPrice } from "../../utils/utils"

const REQUIRED_VALUE = "PLEASE ENTER THE VALUE"
const REDIRECT_URL="/foundationData/priceMatrix"
const Calculate = () => {
    const navigate = useNavigate()
    const [showPagination, setShowPagination] = useState(true)
    const [customsearchtext, setcustomsearchtext] = useState("")
    const [pagination, setPagination] = useState(PAGINATION)
    const[pageSize,setPageSize]= useState(pagination.pageSize)
    const [loader, setLoader] = useState(false)
    const [totalRecords, setTotalRecords] = useState(0)
    const [data, setData] = useState([])
    const [errors, setErrors] = useState({})
    const [key, setKey] = useState(0)
    const [typeIdList, setTypeIdList] = useState([])

    const [filterValueDefault, setFilterValueDefault] = useState({
        priceList: null,
        typeNumber: [],
        eanNumber: null,
        articleNo: null,
        articleName: null,
        materialClass: null
    })
    const [filter, setFilter] = useState({
        priceList: [],
        typeNumber: [],
        eanNumber: [],
        articleNo: [],
        articleName: [],
        materialClass: []
    })
    const [newCombineFilter, setNewCombineFilter] = useState({
        priceList: [],
        typeNumber: [],
        eanNumber: [],
        articleNo: [],
        articleName: [],
        materialClass: []
    })
    const [disabledFilterItem, setDisabledFilterItem] = useState({
        eanNumber: false,
        articleNo: false,
        articleName: false,
        materialClass: false
    })

    const { data: priceListNames } = useGetPriceListNames()
    const { data: typeNumberList } = useGettypeNumberList()
    const { data: articleDetails } = useGetArticleDetails(typeIdList)

    useEffect(()=>{
        if(articleDetails?.article_no?.length>0){
            setKey((prevState => prevState + 1))
        }
    },[articleDetails])
    const eanNumbers = articleDetails?.ean || []
    const articleNumbers = articleDetails?.article_no || []
    const articleNames = articleDetails?.article_name || []
    const materialClass = articleDetails?.material_class || []

    const priceListOption = priceListNames?.map((priceList) => ({
        value: priceList?.id,
        label: priceList?.name
    }))
    const typeNumberListOptions = typeNumberList?.data && typeNumberList?.data?.map((typeNumber) => ({
        value: typeNumber?.id,
        label: typeNumber?.type_no
    }))
    const eanNumberOptions = eanNumbers?.filter((obj) => obj?.value != null)
        .map((obj) => ({
            value: obj?.id,
            label: obj?.value,
            mc: obj?.mc
        }))
    const articleNumberOptions = articleNumbers?.map((obj) => ({
        value: obj?.id,
        label: obj?.value,
        mc: obj?.mc
    }))
    const articleNameOptions = articleNames?.map((obj) => ({
        value: obj?.id,
        label: obj?.value,
        mc: obj?.mc
    }))
    const materialClassOptions = materialClass?.map((obj) => ({
        value: obj?.id,
        label: obj?.value
    }))

    const onSelectFilterChange = (selectedOption, filterType) => {
        const filterValues = Array.isArray(selectedOption) ? 
            selectedOption.map((option) => option?.value) : [selectedOption?.value]

        if(filterType === "priceList"){
            setErrors({
                ...errors,
                [filterType]: ""
            })
        }
        if( filterType == "typeNumber" ) {       
            setFilterValueDefault({
                priceList: null,
                typeNumber: null,
                eanNumber: null,
                articleNo: null,
                articleName: null,
                materialClass: null
            })     
            if( filterValues.length > 0 ) {                
                setTypeIdList(filterValues)                
            } else {
                setTypeIdList([])
                setFilter({
                    ...filter,
                    eanNumber: [],
                    articleNo: [],
                    articleName: [],
                    materialClass: []
                })
                setNewCombineFilter({
                    ...newCombineFilter,
                    eanNumber: [],
                    articleNo: [],
                    articleName: [],
                    materialClass: []
                })
                setFilterValueDefault({
                    ...filterValueDefault,
                    eanNumber: [],
                    articleNo: [],
                    articleName: [],
                    materialClass: []
                })
                setDisabledFilterItem((data) => {
                    return {
                        ...data,
                        "articleNo": false,
                        "articleName": false,
                        "materialClass": false
                    }
                })
            }
        }

        const newFilterItems = {
            [filterType]: filterValues
        }
        const newFilterValueDefault = {
            [filterType]: selectedOption
        }

        if( filterType == "eanNumber" ) {
            if( filterValues.length > 0 ) {
                const newArticleNumberOptions = articleNumberOptions?.filter(val => filterValues.includes(val?.value))
                const newArticleNameOptions = articleNameOptions?.filter(val => filterValues.includes(val?.value))

                const articleNumberFilterValues = Array.isArray(newArticleNumberOptions) ? 
                    newArticleNumberOptions.map((option) => option.value) : [newArticleNumberOptions?.value]
                const articleNameFilterValues = Array.isArray(newArticleNameOptions) ? 
                    newArticleNameOptions.map((option) => option.value) : [newArticleNameOptions?.value]
                

                newFilterItems["articleNo"] = articleNumberFilterValues
                newFilterValueDefault["articleNo"] = newArticleNumberOptions

                newFilterItems["articleName"] = articleNameFilterValues
                newFilterValueDefault["articleName"] = newArticleNameOptions

                setDisabledFilterItem((data) => {
                    return {
                        ...data,
                        "articleNo": true,
                        "articleName": true
                    }
                })
            }
            else {
                newFilterItems["articleNo"] = []
                newFilterValueDefault["articleNo"] = null

                newFilterItems["articleName"] = []
                newFilterValueDefault["articleName"] = null

                setDisabledFilterItem((data) => {
                    return {
                        ...data,
                        "articleNo": false,
                        "articleName": false
                    }
                })
            }
        }

        if( filterType == "articleNo" ) {
            if( filterValues.length > 0 ) {
                const newEanOptions = eanNumberOptions?.filter(val => filterValues.includes(val?.value))
                const newArticleNameOptions = articleNameOptions?.filter(val => filterValues.includes(val?.value))

                const eanFilterValues = Array.isArray(newEanOptions) ? 
                    newEanOptions.map((option) => option.value) : [newEanOptions?.value]
                const articleNameFilterValues = Array.isArray(newArticleNameOptions) ? 
                    newArticleNameOptions.map((option) => option.value) : [newArticleNameOptions?.value]
                

                newFilterItems["eanNumber"] = eanFilterValues
                newFilterValueDefault["eanNumber"] = newEanOptions

                newFilterItems["articleName"] = articleNameFilterValues
                newFilterValueDefault["articleName"] = newArticleNameOptions

                setDisabledFilterItem((data) => {
                    return {
                        ...data,
                        "eanNumber": true,
                        "articleName": true
                    }
                })
            }
            else {
                newFilterItems["eanNumber"] = []
                newFilterValueDefault["eanNumber"] = null

                newFilterItems["articleName"] = []
                newFilterValueDefault["articleName"] = null

                setDisabledFilterItem((data) => {
                    return {
                        ...data,
                        "eanNumber": false,
                        "articleName": false
                    }
                })
            }
        }

        if( filterType == "articleName" ) {
            if( filterValues.length > 0 ) {
                const newEanOptions = eanNumberOptions?.filter(val => filterValues.includes(val?.value))
                const newArticleNumberOptions = articleNumberOptions?.filter(val => filterValues.includes(val?.value))

                const eanFilterValues = Array.isArray(newEanOptions) ? 
                    newEanOptions.map((option) => option.value) : [newEanOptions?.value]
                const articleNumberFilterValues = Array.isArray(newArticleNumberOptions) ? 
                    newArticleNumberOptions.map((option) => option.value) : [newArticleNumberOptions?.value]
                

                newFilterItems["eanNumber"] = eanFilterValues
                newFilterValueDefault["eanNumber"] = newEanOptions

                newFilterItems["articleNo"] = articleNumberFilterValues
                newFilterValueDefault["articleNo"] = newArticleNumberOptions

                setDisabledFilterItem((data) => {
                    return {
                        ...data,
                        "eanNumber": true,
                        "articleNo": true
                    }
                })
            }
            else {
                newFilterItems["eanNumber"] = []
                newFilterValueDefault["eanNumber"] = null

                newFilterItems["articleNo"] = []
                newFilterValueDefault["articleNo"] = null

                setDisabledFilterItem((data) => {
                    return {
                        ...data,
                        "eanNumber": false,
                        "articleNo": false
                    }
                })
            }
        }

        if( filterType == "eanNumber" || filterType == "articleNo" || filterType == "articleName" ) {
            if( filterValues.length > 0 ) {
                const selectedMCLabels = Array.isArray(selectedOption) ? 
                    selectedOption.map((option) => option?.mc) : [selectedOption?.mc]
                const selectedMCIds = materialClassOptions?.filter(obj => selectedMCLabels.includes(obj?.label))?.map(obj => obj?.value)
                const newMaterialClassOptions = materialClassOptions?.filter(val => selectedMCLabels.includes(val?.label))
                
                newFilterItems["materialClass"] = selectedMCIds
                newFilterValueDefault["materialClass"] = newMaterialClassOptions

                setDisabledFilterItem((data) => {
                    return {
                        ...data,
                        "materialClass": true
                    }
                })
            }
            else {
                newFilterItems["materialClass"] = []
                newFilterValueDefault["materialClass"] = null

                setDisabledFilterItem((data) => {
                    return {
                        ...data,
                        "materialClass": false
                    }
                })
            }
        }

        setFilter((data) => {
            return {
                ...data,
                ...newFilterItems
            }
        })
        setFilterValueDefault((data) => {
            return {
                ...data,
                ...newFilterValueDefault
            }
        })
    }

    const filterData = () => {

        setPagination({ ...pagination, pageIndex: 1 })
        if(filter?.priceList?.length > 0){
            setNewCombineFilter(filter)
            queryClient.invalidateQueries({
                queryKey: ["priceEngineSimulation"]
            })
        }
        else{
            setErrors({
                priceList : REQUIRED_VALUE
            })
        }
    }

    const clearFilter = () => {        
        setFilterValueDefault({
            priceList: null,
            typeNumber: null,
            eanNumber: null,
            articleNo: null,
            articleName: null,
            materialClass: null
        })
        setFilter({
            priceList: [],
            typeNumber: [],
            eanNumber: [],
            articleNo: [],
            articleName: [],
            materialClass: []
        })
        setNewCombineFilter({
            priceList: [],
            typeNumber: [],
            eanNumber: [],
            articleNo: [],
            articleName: [],
            materialClass: []
        })
        setDisabledFilterItem({
            eanNumber: false,
            articleNo: false,
            articleName: false,
            materialClass: false
        })
        setKey((prevState => prevState + 1))
        setData([])
        setTotalRecords(0)
    }
    const countryDetail = sessionStorage?.getItem("countryDetails") && JSON.parse(sessionStorage?.getItem("countryDetails"))

    const column = [
        {
            Header: t("calculate.priceList"),
            accessor: "pricelist_name"
        },
        {
            Header: t("calculate.typeNo"),
            accessor: "type_no"
        },
        {
            Header: t("calculate.ean"),
            accessor: "ean"
        },
        {
            Header: t("calculate.articleNumber"),
            accessor: "article_no"
        },
        {
            Header: t("calculate.articleName"),
            accessor: "article_name"
        },
        {
            Header: t("calculate.materialClass"),
            accessor: "material_class"
        },
        {
            Header: t("calculate.currency"),
            accessor: "currency"
        },
        {
            Header: t("calculate.listPriceImport"),
            accessor: "base_price",
            Cell: ({ value }) => (
                <div className="flex flex-col">
                    <span className="text-right">{ (countryDetail && countryDetail.length>0) ? formatPrice(value) : value }</span>
                </div>
            )
        },
        {
            Header: t("calculate.reimbursementPrice"),
            accessor: "reimbursement_price",
            Cell: ({ value }) => (
                <div className="flex flex-col">
                    <span className="text-right">{ (countryDetail && countryDetail.length>0) ? formatPrice(value) : value }</span>
                </div>
            )
        },
        {
            Header: t("calculate.orderPrice"),
            accessor: "order_price",
            Cell: ({ value }) => (
                <div className="flex flex-col">
                    <span className="text-right">{ (countryDetail && countryDetail.length>0) ? formatPrice(value) : value }</span>
                </div>
            )
        },
        {
            Header: t("calculate.endConsumerPrice"),
            accessor: "consumer_price",
            Cell: ({ value }) => (
                <div className="flex flex-col">
                    <span className="text-right">{ (countryDetail && countryDetail.length>0) ? formatPrice(value) : value }</span>
                </div>
            )
        }
    ]

    const { data: filteredResult = [], status } = useGetFilteredPriceEngineSimulation(
        pagination.pageIndex,
        pageSize || pagination.pageSize,
        customsearchtext,
        newCombineFilter
    )

    useEffect(() => {
        if (filteredResult?.data) {
            setData((prevData) => {
                if (JSON.stringify(prevData) !== JSON.stringify(filteredResult.data)) {
                    return filteredResult.data
                }
                return prevData
            })
            setTotalRecords((prevTotal) => {
                if (prevTotal !== filteredResult?.total_count) {
                    return filteredResult?.total_count
                }
                return prevTotal
            })
            setLoader(false)
        }
    }, [filteredResult, customsearchtext])

    const onCustomSearch = async (searchText) => {
        setcustomsearchtext(searchText)
        setPagination({ ...pagination, pageIndex: 1 })
    }

    const onPaginationClicked  = (index) => {
        setPagination({ ...pagination, pageIndex: index })
    }

    const downloadObj = {
        fileName: "Price_Matrix_List",
        sheet: "ProceMatrixList"
    }

    const { mutateAsync: DownloadPriceEngineSimulationData } = DownloadPriceEngineSimulation(filter)

    const onDownloadData = async () => {
        try {
            setLoader(true)
            let result = await DownloadPriceEngineSimulationData(newCombineFilter)
            const { data: response } = result
            const newResult =  response?.map((record) => {
                return {
                    [t("calculate.priceList")]: record?.pricelist_name,
                    [t("calculate.typeNo")]: record?.type_no,
                    [t("calculate.ean")]: record?.ean,
                    [t("calculate.articleNumber")]: record?.article_no,
                    [t("calculate.articleName")]: record?.article_name,
                    [t("calculate.materialClass")]: record?.material_class,
                    [t("calculate.currency")]: record?.currency,
                    [t("calculate.listPrice")]: record?.base_price,
                    [t("calculate.reimbursementPrice")]: record?.reimbursement_price,
                    [t("calculate.orderPrice")]: record?.order_price,
                    [t("calculate.endConsumerPrice")]: record?.consumer_price
                }
            })
            setLoader(false)
            return newResult || []
        } catch (ex) {
            if (ex?.message) {
                notify("ERROR", customNotification(ex.message, t))
            }
            setLoader(false)
            return []
        }
    }

    return (
        <>
            <div className="headings px-8 mb-4">
                <h1 className="flex items-center text-2xl text-primary-50 font-black ml-2 ">
                    <Link
                        onClick={ () => navigate(REDIRECT_URL) }
                        className=" flex items-center"
                    >
                        <img src={ leftArrow } alt="Back Arrow" className="mr-3" />{ " " }
                        { t("calculate.calculate") }
                    </Link>
                </h1>
            </div>
            <div className="bg-primary-200 py-4 gap-4 px-12 mb-4">
                <div className="border border-secondary-300 rounded-lg bg-white ">
                    <div className="flex justify-between gap-4 items-center px-4">
                        <h3 className="text-md font-black text-primary-50 pt-4">{ `${t(
                            "calculate.calculate"
                        )}` }</h3>
                    </div>
                    <div className="flex gap-4 pt-5 px-4">
                        <div className="w-1/6">
                            <CustomDropdown
                                placeholder={ t("calculate.priceList") }
                                defaultValue={ filterValueDefault?.priceList || [] }
                                options={ priceListOption || [] }
                                name="priceList"
                                changeHandler={ onSelectFilterChange }
                                errorData={ errors }
                                isRequired={ true }
                                disabled={ false }
                                dataTestId="priceList"
                                isUnselectEnabled={ true }
                                renderKey={ key }
                            />
                        </div>
                        <div className="w-1/6">

                            <CustomDropdown
                                placeholder={ t("calculate.typeNo") }
                                defaultValue={ filterValueDefault?.typeNumber || [] }
                                options={ typeNumberListOptions || [] }
                                name="typeNumber"
                                changeHandler={ onSelectFilterChange }
                                errorData={ "" }
                                isRequired={ false }
                                disabled={ false }
                                dataTestId="typeNumber"
                                isMulti={ true }
                                isMultiWithCheckbox={ true }
                                selectedItemLength ={ 1 }
                                renderKey={ key }
                                AllSelectLabel = { "ALL" }
                                isAllOption = { true }
                                isValueSelect={ true }
                                isUnselectEnabled={ true }
                            />
                        </div> 
                        <div className="w-1/6">
                            <CustomDropdown
                                placeholder={ t("calculate.ean") }
                                defaultValue={ filterValueDefault?.eanNumber || [] }
                                options={ eanNumberOptions || [] }
                                name="eanNumber"
                                changeHandler={ onSelectFilterChange }
                                errorData={ "" }
                                isRequired={ false }
                                dataTestId="eanNumber"
                                isMulti={ true }
                                isMultiWithCheckbox={ true }
                                selectedItemLength ={ 1 }
                                isValueSelect={ true }
                                disabled={ disabledFilterItem?.eanNumber? true : false }
                                renderKey={ key }
                                AllSelectLabel = { "ALL" }
                                isAllOption = { true }
                            />
                        </div>
                        <div className="w-1/6">
                            <CustomDropdown
                                placeholder={ t("calculate.articleNo") }
                                defaultValue={ filterValueDefault?.articleNo || [] }
                                options={ articleNumberOptions || [] }
                                name="articleNo"
                                changeHandler={ onSelectFilterChange }
                                errorData={ "" }
                                isRequired={ false }
                                dataTestId="articleNo"
                                isMulti={ true }
                                isMultiWithCheckbox={ true }
                                selectedItemLength ={ 1 }
                                isValueSelect={ true }
                                disabled={ disabledFilterItem?.articleNo? true : false }
                                renderKey={ key }
                                AllSelectLabel = { "ALL" }
                                isAllOption = { true }
                                isUnselectEnabled ={ true }
                            />
                        </div>
                        <div className="w-1/6">
                            <CustomDropdown
                                placeholder={ t("calculate.articleName") }
                                defaultValue={ filterValueDefault?.articleName || [] }
                                options={ articleNameOptions || [] }
                                name="articleName"
                                changeHandler={ onSelectFilterChange }
                                errorData={ "" }
                                isRequired={ false }
                                dataTestId="articleName"
                                isMulti={ true }
                                isMultiWithCheckbox={ true }
                                selectedItemLength ={ 1 }
                                isValueSelect={ true }
                                disabled={ disabledFilterItem?.articleName }
                                renderKey={ key }
                                AllSelectLabel = { "ALL" }
                                isAllOption = { true }
                            />
                        </div>
                        <div className="w-1/6">
                            <CustomDropdown
                                placeholder={ t("calculate.materialClass") }
                                defaultValue={ filterValueDefault?.materialClass || [] }
                                options={ materialClassOptions || [] }
                                name="materialClass"
                                changeHandler={ onSelectFilterChange }
                                errorData={ "" }
                                isRequired={ false }
                                disabled={ disabledFilterItem?.materialClass }
                                dataTestId="materialClass"
                                isMulti={ true }
                                isMultiWithCheckbox={ true }
                                isValueSelect={ true }
                                selectedItemLength ={ 1 }
                                renderKey={ key }
                                AllSelectLabel = { "ALL" }
                                isAllOption = { true }
                            />
                        </div>
                    </div>
                    <div className="flex gap-4 pt-5 px-4">
                        <div className="flex w-full justify-end pb-4">
                            <button
                                type="button"
                                onClick={ () => { clearFilter() } }
                                className="rounded-full border border-primary-100 text-primary-100 font-bold text-sm  hover:bg-primary-150 hover:text-primary-50 h-9 px-4 mr-4"
                            >
                                { t("calculate.clear") }
                            </button>
                            <button
                                type="button"
                                onClick={ () => { filterData() } }
                                className="rounded-full bg-primary-100 text-white font-bold text-sm hover:bg-primary-150 hover:text-primary-50 h-9 px-4"
                            >
                                { t("calculate.calculate") }
                            </button>
                        </div>
                    </div>
                    <div className="flex flex-col bg-white py-4 rounded-lg gap-4">
                        <Table
                            columns={ column }
                            data={ data }
                            translateFeature={ false }
                            setShowPagination={ setShowPagination }
                            onCustomSearch={ onCustomSearch }
                            isCustomSearch={ true }
                            customsearchtext={ customsearchtext }
                            status={ status }
                            loader={ loader }
                            downloadFeature={ true }
                            downloadData={ downloadObj }
                            getDownloadData={ onDownloadData }
                            isJsondownload={ true }
                        />
                        { showPagination && (
                            <Pagination
                                totalrecords={ totalRecords }
                                PaginationState={ pagination }
                                onPaginationClicked={ onPaginationClicked }
                                pageSize={ pageSize }
                                setPageSize={ setPageSize }

                            />
                        ) }
                    </div>
                </div>
            </div>
            <ToastNotification />
        </>

    )
}

export default Calculate
